<template>
  <div>
    <div v-if="ready">
      <div class="q-headline">Companies Pending Approval</div>
      <q-card class="mdi-card q-mb-lg">
        <q-card-main class="q-pa-none">
          <!-- TABLE OF COMPANIES -->
          <q-table
            title="Companies Pending Approval"
            v-if="companies && companies.length > 0 && companyTable.columns"
            :data="companies"
            :columns="companyTable.columns"
            row-key="id"
            selection="multiple"
            :selected.sync="companyTable.selected"
            dense
            :filter="companyTable.terms"
            :filter-method="companyTable.myFilter"
            :pagination.sync="companyTable.pagination"
            :rows-per-page-options="[0, 25, 50, 100, 250, 500]"
          >
            <div slot="top" slot-scope="props" class="full-width q-pt-sm q-pb-sm">
              <transition mode="out-in" enter-active-class="animated flipInX" leave-active-class="animated flipOutX">
                <!-- SEARCH -->
                <div v-if="!companyTable.selected.length" key="search-bar" class="row flex-center gutter-md" style="animation-duration: 0.4s">
                  <div class="col-6">
                    <q-search hide-underline v-model="companyTable.terms"/>
                  </div>
                  <!-- ICONS -->
                  <div class="col text-right">
                    <q-btn flat round dense :icon="props.inFullscreen ? 'fullscreen_exit' : 'fullscreen'" @click="props.toggleFullscreen"/>
                  </div>
                </div>
                <!-- BULK -->
                <div key="bulk-update-bar" class="row flex-center gutter-md" style="animation-duration: 0.4s" v-else>
                  <div class="col text-right">
                    <q-btn color="positive" flat delete label="Approve Selected" icon="add" @click="handleBatchApprove('company')"></q-btn>
<!--                    <q-btn color="negative" flat delete label="Deny Selected" icon="add" @click="handleBatchDeny('company')"></q-btn>-->
                  </div>
                </div>
              </transition>
            </div>
            <q-tr slot="header" slot-scope="props">
              <q-th auto-width>
                <q-checkbox v-if="props.multipleSelect" v-model="props.selected" indeterminate-value="some"/>
              </q-th>
              <q-th v-for="col in props.cols" :key="col.name" :props="props">{{ col.label }}</q-th>
            </q-tr>
            <!-- BODY -->
            <template slot="body" slot-scope="props">
              <q-tr :props="props">
                <q-td auto-width>
                  <q-checkbox color="primary" v-model="props.selected"/>
                </q-td>
                <q-td key="id" :props="props">
                  <q-btn icon="pageview" flat color="primary" @click="openCompareModal(props.row, 'company')"/>
                </q-td>
                <q-td key="isNew" :props="props">
                  <q-icon name="check" color="positive" v-if="props.row.isNew" />
                  <q-icon name="clear" color="faded" v-else />
                </q-td>
                <q-td key="name" :props="props"><strong>{{ props.row.name }}</strong></q-td>
                <q-td key="membershipRegistrationDate" :props="props">
                  <span v-if="props.row.membership && props.row.membership.membershipPeriod && props.row.membership.membershipPeriod[0] && props.row.membership.membershipPeriod[0].registrationDate">{{ props.row.membership.membershipPeriod[0].registrationDate | formatDate }}</span>
                </q-td>
                <q-td key="membershipType" :props="props">
                  <span v-if="props.row.membership && props.row.membership.membershipType && props.row.membership.membershipType.description">{{ props.row.membership.membershipType.description }}</span>
                </q-td>
                <q-td key="phoneNumber" :props="props">
                  <span v-if="props.row.phoneNumber">{{ props.row.phoneNumber }}</span>
                </q-td>
                <q-td key="primaryEmail" :props="props">
                  <span v-if="props.row.primaryPerson && props.row.primaryPerson.emailAddress">{{ props.row.primaryPerson.emailAddress }}</span>
                </q-td>
                <q-td key="primaryPhone" :props="props">
                  <span v-if="props.row.primaryPerson && props.row.primaryPerson.workNumber">{{ props.row.primaryPerson.workNumber }}</span>
                </q-td>
              </q-tr>
            </template>
          </q-table>
          <q-alert type="negative" v-else>No companies pending approval</q-alert>
        </q-card-main>
      </q-card>
      <div class="q-headline">Persons Pending Approval</div>
      <q-card class="mdi-card q-mb-lg">
        <q-card-main class="q-pa-none">
          <!-- TABLE OF PERSONS -->
          <q-table
            title="Persons Pending Approval"
            v-if="filteredPersons && filteredPersons.length > 0 && personTable.columns"
            :data="filteredPersons"
            :columns="personTable.columns"
            row-key="id"
            selection="multiple"
            :selected.sync="personTable.selected"
            dense
            :filter="personTable.terms"
            :filter-method="personTable.myFilter"
            :pagination.sync="personTable.pagination"
            :rows-per-page-options="[0, 25, 50, 100, 250, 500]"
          >
            <div slot="top" slot-scope="props" class="full-width q-pt-sm q-pb-sm">
              <transition mode="out-in" enter-active-class="animated flipInX" leave-active-class="animated flipOutX">
                <!-- SEARCH -->
                <div v-if="!personTable.selected.length" key="search-bar" class="row flex-center gutter-md" style="animation-duration: 0.4s">
                  <div class="col-6">
                    <q-search hide-underline v-model="personTable.terms"/>
                  </div>
                  <!-- ICONS -->
                  <div class="col text-right">
                    <q-btn flat round dense :icon="props.inFullscreen ? 'fullscreen_exit' : 'fullscreen'" @click="props.toggleFullscreen"/>
                  </div>
                </div>
                <!-- BULK -->
                <div key="bulk-update-bar" class="row flex-center gutter-md" style="animation-duration: 0.4s" v-else>
                  <div class="col text-right">
                    <q-btn color="positive" flat delete label="Approve Selected" icon="add" @click="handleBatchApprove('person')"></q-btn>
<!--                    <q-btn color="negative" flat delete label="Deny Selected" icon="add" @click="handleBatchDeny('person')"></q-btn>-->
                  </div>
                </div>
              </transition>
            </div>
            <q-tr slot="header" slot-scope="props">
              <q-th auto-width>
                <q-checkbox v-if="props.multipleSelect" v-model="props.selected" indeterminate-value="some"/>
              </q-th>
              <q-th v-for="col in props.cols" :key="col.name" :props="props">{{ col.label }}</q-th>
            </q-tr>
            <!-- BODY -->
            <template slot="body" slot-scope="props">
              <q-tr :props="props">
                <q-td auto-width>
                  <q-checkbox color="primary" v-model="props.selected"/>
                </q-td>
                <q-td key="id" :props="props">
                  <q-btn icon="pageview" flat color="primary" @click="openCompareModal(props.row, 'person')"/>
                </q-td>
                <q-td key="isNew" :props="props">
                  <q-icon name="check" color="positive" v-if="props.row.isNew" />
                  <q-icon name="clear" color="faded" v-else />
                </q-td>
                <q-td key="firstName" :props="props">{{ props.row.firstName }}</q-td>
                <q-td key="lastName" :props="props">{{ props.row.lastName }}</q-td>
                <q-td key="profession" :props="props">{{ props.row.profession }}</q-td>
                <q-td key="email" :props="props">{{ props.row.emailAddress }}</q-td>
                <q-td key="phone" :props="props">{{ props.row.workNumber }}</q-td>
                <q-td key="updatedAt" :props="props">{{ props.row.updatedAt | formatDate }}</q-td>
              </q-tr>
            </template>
          </q-table>
          <q-alert type="negative" v-else>No persons pending approval</q-alert>
        </q-card-main>
      </q-card>
      <q-modal v-model="compareFormModalOpen" content-classes="q-pa-lg" content-css="min-width: 70vw; max-width: 95vw" no-backdrop-dismiss no-esc-dismiss>
        <div class="fit">
          <q-btn flat icon="close" class style="top: 0; right: 0; position: relative; float: right" @click="compareFormModalOpen = false"></q-btn>
          <compare-form :relation-resource="compareFormRelationResource" :new-record="compareFormNewRecord" @approve="handleFormApprove" @deny="handleFormDeny" :key="compareFormComponentKey" v-if="compareFormModalOpen && compareFormNewRecord && compareFormRelationResource"></compare-form>
          <div v-else>No record found</div>
        </div>
        <div class="full-width q-mt-md q-pb-lg">
          <q-btn icon="close" label="Cancel / Close" color="grey-6" @click="compareFormModalOpen = false" flat/>
        </div>
      </q-modal>
    </div>
    <q-inner-loading :visible="loading"></q-inner-loading>
  </div>
</template>

<script>
  import CompareForm from '../../components/form/CompareForm'
  import companyModule from '../../modules/company/index'
  import {dateFormat} from '../../plugins/filters'
  import {normalizeDate} from '../../utils/dateHelpers'

  export default {
  name: 'PendingChanges',
  components: {CompareForm},
  data () {
    return {
      loading: true,
      ready: false,
      compareFormModalOpen: false,
      compareFormNewRecord: {},
      compareFormRelationResource: '',
      compareFormComponentKey: 0,
      persons: [],
      companies: [],
      personTable: {
        selected: [],
        filter: '',
        terms: '',
        massSelectOptionSelected: null,
        massSelectOptions: [
          {label: '', value: ''}
        ],
        pagination: {
          // sortBy: 'id', // String, column "name" property value
          sortBy: 'updatedAt',
          descending: false,
          page: 1,
          rowsPerPage: 500 // current rows per page being displayed
        },
        columns: [
          {name: 'id', label: 'Review', field: 'id', sortable: false, align: 'left'},
          {name: 'isNew', label: 'New', field: 'isNew', sortable: true, align: 'left'},
          {name: 'firstName', label: 'First Name', field: 'firstName', sortable: true, align: 'left'},
          {name: 'lastName', label: 'Last Name', field: 'lastName', sortable: true, align: 'left'},
          {name: 'profession', label: 'Title', field: 'profession', sortable: true, align: 'left'},
          {name: 'email', label: 'Email', field: 'emailAddress', sortable: true, align: 'left'},
          {name: 'phone', label: 'Phone', field: 'workNumber', sortable: true, align: 'left'},
          {name: 'updatedAt', label: 'Last Updated', field: 'updatedAt', sortable: true, align: 'left'}
        ]
      },
      companyTable: {
        selected: [],
        filter: '',
        terms: '',
        massSelectOptionSelected: null,
        massSelectOptions: [
          {label: '', value: ''}
        ],
        pagination: {
          // sortBy: 'id', // String, column "name" property value
          sortBy: 'updatedAt',
          descending: false,
          page: 1,
          rowsPerPage: 500 // current rows per page being displayed
        },
        columns: [
          {name: 'id', label: 'Review', field: 'id', sortable: false, align: 'left'},
          {name: 'isNew', label: 'New', field: 'isNew', sortable: true, align: 'left'},
          {name: 'name', label: 'Name', field: 'name', sortable: true, align: 'left'},
          {name: 'membershipRegistrationDate', label: 'Membership Registration', field: x => x.membership && x.membership.membershipPeriod && x.membership.membershipPeriod[0] && x.membership.membershipPeriod[0].registrationDate ? x.membership.membershipPeriod[0].registrationDate : null, sortable: true, align: 'left'},
          {name: 'membershipType', label: 'Membership Type', field: x => x.membership && x.membership.membershipType && x.membership.membershipType.description ? x.membership.membershipType.description : null, sortable: true, align: 'left'},
          {name: 'phoneNumber', label: 'Company Phone', field: 'phoneNumber', sortable: true, align: 'left'},
          {name: 'primaryEmail', label: 'Primary Email', field: x => x.primaryPerson && x.primaryPerson.emailAddress ? x.primaryPerson.emailAddress : '', sortable: true, align: 'left'},
          {name: 'primaryPhone', label: 'Primary Phone', field: x => x.primaryPerson && x.primaryPerson.workNumber ? x.primaryPerson.workNumber : '', sortable: true, align: 'left'}
        ]
      }
    }
  },
  async beforeCreate () {
    await this.$registerModule(companyModule)
  },
  async created () {
    await this.getPersonsTwo()
    await this.getCompaniesTwo()
    // console.log('this.$store.state[person]', this.$store.state['person'])
    this.ready = true
    this.loading = false
  },
  computed: {
    filteredPersons () {
      return this.persons.filter(person => this.companyExists(person))
    }
  },
  filters: {
    formatDate (date) {
      return dateFormat(date)
    }
  },
  methods: {
    handleBaseEdit (val) {
      console.log(val)
    },
    companyExists (person) {
      for (let company of this.companies) {
        if (company.id === person.companyId) {
          return false
        }
      }
      return true
    },
    openCompareModal (record, resource) {
      this.compareFormComponentKey += 1
      this.$set(this, 'compareFormComponentKey', this.compareFormComponentKey + 1)
      this.$set(this, 'compareFormNewRecord', record)
      this.$set(this, 'compareFormRelationResource', resource)
      this.$set(this, 'compareFormModalOpen', true)
    },
    handleFormApprove (form, resource, pendingApproval) {
      // console.log('handleApprove', form, resource, pendingApproval)
      this.handleApprove(resource, form.id, form.isNew)
      this.compareFormModalOpen = false
      if (resource === 'company' && pendingApproval && form.isNew) {
        let personsToApprove = this.persons.filter(person => person.companyId && person.companyId === form.id)
        if (personsToApprove && personsToApprove.length) {
          for (let person of personsToApprove) {
            this.handleApprove('person', person.id, true)
          }
        }
      }
    },
    handleFormDeny (form, resource, pendingApproval) {
      // console.log('handleDeny', form, resource, pendingApproval)
      this.handleDeny(resource, form.id)
      this.compareFormModalOpen = false
    },
    removeRecord (id, resource) {
      if (resource === 'company') {
        let index = this.companies.findIndex(company => company.id === id)
        this.$delete(this.companies, index)
      } else if (resource === 'person') {
        let index = this.persons.findIndex(person => person.id === id)
        this.$delete(this.persons, index)
      }
    },
    async handleApprove (resource, id, isNew = false) {
      // console.log('handleApprove', resource, id, isNew)
      // TODO: if isNew then do
      if (isNew) {
        let model = {approved: true, isNew: false, dateApproved: normalizeDate(null, 'mysql')}
        const data = this.$axios
          .put(`/api/${resource}/${id}`, model)
          .then(response => {
            if (data) {
              this.removeRecord(id, resource)
              // console.log('handleApprove data', data)
            }
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        const data = this.$axios
          .post(`/api/${resource}/approve/${id}`)
          .then(response => {
            if (data) {
              this.removeRecord(id, resource)
              // console.log('handleApprove data', data)
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    async handleDeny (resource, id) {
      console.log('deny')
      // const data = this.$axios
      //   .post(`/api/${resource}/deny/${id}`)
      //   .then(response => {
      //     if (data) {
      //       this.removeRecord(id, resource)
      //       console.log(data)
      //     }
      //   })
      //   .catch(error => {
      //     console.log(error)
      //   })
    },
    async handleBatchApprove (resource) {
      // console.log('Dialog here then delete')
      // console.log(this[resource + 'Table'].selected, resource + 'Table')
      this.$q
        .dialog({
          title: 'Confirm Approval of the selected',
          message: 'Are you sure you want to approve the selected records?',
          ok: {
            label: 'Approve',
            color: 'positive'
          },
          cancel: true
        })
        .then(() => {
          // console.log(this.selected)
          if (this[resource + 'Table'].selected && this[resource + 'Table'].selected.length > 0) {
            for (let record of this[resource + 'Table'].selected) {
              this.handleApprove(resource, record.id, record.isNew)
              // TODO: if isNew then do puts
              if (resource === 'company' && record.isNew) {
                let personsToApprove = this.persons.filter(person => person.companyId && person.companyId === record.id)
                if (personsToApprove && personsToApprove.length) {
                  for (let person of personsToApprove) {
                    this.handleApprove('person', person.id, true)
                  }
                }
              }
            }
            this.selected = []
            // this.getAttendees()
            this.$q.notify({
              message: `Records Approved`,
              type: 'positive'
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    async handleBatchDeny (resource) {
      // console.log('Dialog here then delete')
      this.$q
        .dialog({
          title: 'Confirm Denial of the selected',
          message: 'Are you sure you want to deny the selected records?',
          ok: {
            label: 'Deny',
            color: 'negative'
          },
          cancel: true
        })
        .then(() => {
          // console.log(this.selected)
          if (this[resource + 'Table'].selected && this[resource + 'Table'].selected.length > 0) {
            for (let record of this[resource + 'Table'].selected) {
              this.handleDeny(resource, record.id)
            }
            this.selected = []
            // this.getAttendees()
            this.$q.notify({
              message: `Records Denied`,
              type: 'positive'
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    async getPersonsTwo () {
      try {
        const {data} = await this.$axios.get('/api/odata/person/paginate', {
          params: {
            $expand: 'Company[$expand=Membership],Aspnetuser,Address,PersonCommittee[$expand=Committee],PersonDietOption[$expand=DietOption],PersonGrouping[$expand=Grouping]',
            // $expand: 'Company[$expand=MailingAddress[$expand=State],Address[$expand=State],AffiliateType,PrimaryPerson,BillingPerson,SafetyPerson,HrPerson,MarketingPerson,CounselPerson,BusinessDevPerson,Comment,Membership[$expand=MembershipType,MembershipPeriod],CompanyDivision[$expand=Division],CompanyLocation[$expand=Address],CompanyProductService[$expand=ProductService],CompanyWorkType[$expand=WorkType]],Aspnetuser,Address,PersonCommittee[$expand=Committee],PersonDietOption[$expand=DietOption],PersonGrouping[$expand=Grouping]',
            $filter: `guestData ne true AND approved ne true AND dateApproved eq null AND removalDate eq null`,
            limit: 500
          }
        })
        if (data && data.data) {
          this.persons = data.data
        } else {
          this.$q.notify({
            message: 'Error fetching person data'
          })
        }
      } catch (e) {
        this.$q.notify({
          message: 'Error fetching person data'
        })
      }
    },
    async getCompaniesTwo () {
      try {
        const {data} = await this.$axios.get('/api/odata/company/paginate', {
          params: {
            $expand: 'MailingAddress[$expand=State],Address[$expand=State],AffiliateType,PrimaryPerson,BillingPerson,SafetyPerson,ChasePerson,HrPerson,MarketingPerson,CounselPerson,BusinessDevPerson,Comment,Membership[$expand=MembershipType],Membership[$expand=MembershipPeriod],CompanyDivision[$expand=Division],CompanyLocation[$expand=Address],CompanyProductService[$expand=ProductService],CompanyWorkType[$expand=WorkType]',
            $filter: `guestData ne true AND approved ne true AND dateApproved eq null AND removalDate eq null`,
            limit: 500
          }
        })
        if (data && data.data) {
          this.companies = data.data
        } else {
          this.$q.notify({
            message: 'Error fetching company data'
          })
        }
      } catch (e) {
        this.$q.notify({
          message: 'Error fetching company data'
        })
      }
    }
  }
}
</script>

<style scoped>
</style>
